import React, { useState, useEffect, useLayoutEffect } from 'react';
import { connect } from 'react-redux';
import { withModelInfo } from '../common/ModelInfoContext';
import { fetchInitialConfig } from '../store/actions';
import fetchFeaturesApi from '../api/fetchFeatures';
import Error from '../views/error/Error';
import Main from './Main';
import Loading from '../common/loading/Loading';
import GlobalNav from './globalNav/GlobalNav';
import GlobalNavPlaceholder from './globalNav/GlobalNavPlaceholder';
import { fetchReservation as fetchReservationAction } from '../store/actions';

const mapStateToProps = (state) => {
  const {
    urls: { modelSelectorUrl, modelOverviewPageUrl },
  } = state.appResources;
  return {
    postalCode: state.params.postalCode,
    shoppingLinks: { modelSelectorUrl, modelOverviewPageUrl },
  };
};

const MainFetch = (props) => {
  const initialState = {
    config: null,
    features: null,
    reservation: null,
    isReservationLoaded: false,
    isLoaded: false,
    isError: false,
    error: '',
  };

  const [state, setState] = useState(initialState);

  const [navRendered, setNavRendered] = useState(false);

  useLayoutEffect(() => {
    const setRendered = () => {
      setNavRendered(true);
    };
    window.addEventListener('gbds-initialRender', setRendered);
    return () => window.removeEventListener('gbds-initialRender', setRendered);
  }, []);

  const { modelInfo, basename } = props;
  const { isEvMode, hasTransactionId } = modelInfo;
  const callReservationApi = isEvMode && hasTransactionId;

  const fetchReservation = () => {
    const { dispatch, modelInfo } = props;
    const { v3ServicesPath, modelPath, transactionId } = modelInfo;
    return new Promise((resolve, reject) => {
      dispatch(
        fetchReservationAction(
          { v3ServicesPath, modelPath, transactionId },
          resolve,
          reject
        )
      );
    });
  };

  useEffect(() => {
    if (callReservationApi) {
      fetchReservation()
        .then((reservation) => {
          setState((prevState) => {
            return {
              ...prevState,
              reservation: reservation,
              isReservationLoaded: true,
            };
          });
        })
        .catch((err) => {
          setState((prevState) => {
            return {
              ...prevState,
              error: err,
              isError: true,
            };
          });
        });
    }
  }, []);

  const fetchConfig = () => {
    const { dispatch, postalCode, modelInfo } = props;
    const { reservation } = state;

    const searchParams = new URLSearchParams(window.location.search);
    const params = {
      ss: searchParams.get('ss'),
      styleId: searchParams.get('styleId') || reservation?.preOrderStyleId,
      hideReveal: searchParams.get('hideReveal') === 'true',
      rpo: searchParams.get('rpo'),
      country: modelInfo.country,
      postalCode,
    };

    if (reservation && reservation.isPreOrderCompleted) {
      const { ss, styleId, postalCode } = reservation;
      params.ss = ss;
      params.styleId = styleId;
      params.postalCode = postalCode;
    }

    // wrapping in promise to ensure we don't continue until complete and resolve config for dependent states
    return new Promise((resolve, reject) => {
      dispatch(fetchInitialConfig(params, resolve, reject));
    });
  };

  const fetchFeatures = () => {
    const { modelInfo } = props;
    const { v3ServicesPath, modelPath } = modelInfo;

    return fetchFeaturesApi({
      v3ServicesPath,
      modelPath,
    }).catch(() => null);
  };

  const fetchData = () => {
    Promise.all([fetchConfig(), fetchFeatures()])
      .then(([config, features]) => {
        setState((prevState) => {
          return {
            ...prevState,
            config: config,
            features: features,
            isLoaded: true,
          };
        });
      })
      .catch((err) => {
        setState((prevState) => {
          return {
            ...prevState,
            error: err,
            isError: true,
          };
        });
      });
  };

  useEffect(() => {
    (!callReservationApi || state.isReservationLoaded) && fetchData();
  }, [state.isReservationLoaded]);

  const { shoppingLinks } = props;
  return (
    <>
      <GlobalNav setNavRendered={setNavRendered} modelInfo={modelInfo} />
      {state.isLoaded ? (
        <>
          {!navRendered && <GlobalNavPlaceholder />}
          <Main
            basename={basename}
            trimFeatures={state.features}
            shoppingLinks={shoppingLinks}
            navRendered={navRendered}
          />
        </>
      ) : state.isError ? (
        <Error error={state.error} />
      ) : (
        <Loading />
      )}
    </>
  );
};

export default withModelInfo(connect(mapStateToProps)(MainFetch));
